import { Checkbox } from '@src/helpers/Formik/formikAntdCompat'
import styled from 'styled-components'

export const StyledCheckbox = styled(Checkbox)`
  margin-top: 1em;
  margin-bottom: 2em;
`
